var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M20.5 14H.5v-2h20zM20.5 8H.5V6h20zM20.5 2H.5V0h20z"}));
}

Menu.defaultProps = {"width":"21","height":"14","fill":"none","viewBox":"0 0 21 14"};

module.exports = Menu;

Menu.default = Menu;
